import { OK } from 'http-status-codes'
import { passThroughAwait } from 'promise-passthrough'
import lrsAdapter from '../../helpers/lrs_adapter'

import getAxiosInstance from '../../helpers/get_axios_instance'
import Token from '../token'

class User {
  static getEmptyUserObject () {
    return {
      authenticated: false,
      user: null,
      error: true,
      roles: [],
      token: null,
      message: 'Usuario y/o clave incorrecto'
    }
  }

  static logout () {
    window.localStorage.setItem('jwToken', null)
    window.localStorage.setItem('userMetadata', null)
    window.localStorage.setItem('jwTokenIntrospect', null)
    return Promise.resolve(true)
  };

  static login (username, password) {
    const axiosInstance = getAxiosInstance()
    const payload = {
      usuario: username,
      credencial: password
    }

    const emptyUser = this.getEmptyUserObject()
    return axiosInstance.post('/authorize', payload)
      .then((response) => {
        const {
          status,
          data: {
            usuario: user,
            roles,
            token
          }
        } = response
        if (status === OK && token) {
          window.localStorage.setItem('jwToken', token)
          window.localStorage.setItem('userMetadata', JSON.stringify({ user, roles }))
          return {
            authenticated: true,
            user,
            roles,
            error: false,
            message: 'Usuario valido'
          }
        }
        return emptyUser
      })
      .then(passThroughAwait(_ => {
        return Token.tokenIntrospect(window.localStorage.getItem('jwToken'))
          .then(tokenIntrospect => {
            window.localStorage.setItem('jwTokenIntrospect',
              JSON.stringify(tokenIntrospect))
          })
      }))
      .catch(_ => emptyUser)
  };

  static getStatus () {
    const emptyUser = { ...this.getEmptyUserObject(), message: null }
    const token = window.localStorage.getItem('jwToken')
    const userMetadata = JSON.parse(window.localStorage.getItem('userMetadata'))

    if (token && userMetadata) {
      return Promise.resolve({
        authenticated: true,
        user: userMetadata['user'],
        roles: userMetadata['roles'],
        error: false
      })
    }
    return Promise.resolve(emptyUser)
  }

  static getInfoUsername (username) {
    const axios = getAxiosInstance()
    const promise = axios.get(`laridae_user?r=` +
      `{"clave":{"user_name": "${username}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data[0])
  }

  static updateInfoUsername (username, mail, telefono) {
    const axios = getAxiosInstance()
    const valores = {
      mail,
      telefono: telefono || null
    }
    const promise = axios.put(`laridae_user`, { valores: { ...valores }, clave: { user_name: username } })
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
      .catch(lrsAdapter)
  }
};

export default User
